import newRequest from "../utils/newRequest";

/// get invoices

export const getAllInvoicesApi = ()=>{
    let result = newRequest.get("/invoice");
    return result
}